export const siteName = `CoinOyez`;
export const siteUrl = `https://www.coinoyez.com`;
export const logoImg = `https://www.coinoyez.com/img/coin-text-logo.png`;
export const siteTitle = `CoinOyez - Maximum Exposure for ICO, Cryptocurrency and Blockchain PR`;
export const siteDesc = `Submit your own ICO, Blockchain and Crypto news stories to more than 450 news outlet including AP, Reuters and Yahoo News.`;